<template>
    <v-text-field
        v-model="inputvalue"
        :label="label"
        prepend-icon="mdi-chevron-right-circle"
        append-outer-icon="mdi-water"
        filled
        clearable>
    </v-text-field>
</template>

<script>
    import { eventBus } from '../../../../../main';

    export default {
        name : 'inputfield',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewcalendar/components/InputField.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Set Input Value.
        *
        */
        mounted() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/InputField.vue >>> mounted');
            this.setInputValue();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/InputField.vue >>> beforeDestroy');
            eventBus.$off('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);

            this.inputvalue = null; // reset

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                inputvalue: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setInputValue();

            }, // eo value()

            inputvalue(value) {

                this.$emit('input', value);

            }, // eo checkbox()

        }, // eo watch{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
        methods : {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /*******************************************************************
            * onDragend_InSelectedProceedingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedProceedingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/InputField.vue >>> onDragend_InSelectedProceedingsList');
                if (this.label === 'Proceeding from Place:') {
                    this.inputvalue = params.proObject.proceedingFrom;
                }
                if (this.label === 'Proceeding to Place:') {
                    this.inputvalue = params.proObject.proceedingTo;
                }

            }, // eo function onDragend_InSelectedProceedingsList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setInputValue()
            *
            * Desc:
            * Note:
            *
            */
            setInputValue: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/InputField.vue >>> setInputValue');
                me.inputvalue = this.value;

            }, // eo function setInputValue()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
</style>